import React, { Fragment } from 'react'
import { cx } from 'emotion'
import styled from 'react-emotion'
import config from 'config'
import { themeGet as th } from 'styled-system'
import ResizeObserver from 'resize-observer-polyfill'

import { SearchKb } from 'ducks/ticketing'

import styles from './styles.less'
import Commenting from './Commenting'
import Replying from './Replying'
import AgentCollision from '../AgentCollision'

// eslint-disable-next-line react/no-multi-comp
const Switcher = props => {
  const {
    loaded,
    commenting,
    showKbSearchOnInboxEditor,
    onEditorFormFocus,
    onEditorFormBlur,
    ticketId,
  } = props
  const editorProps = {
    ...props,
    onFocus: onEditorFormFocus,
    onBlur: onEditorFormBlur,
  }
  const showCommentEditor = loaded && commenting
  return (
    <Fragment>
      <AgentCollision ticketId={ticketId} />
      {showKbSearchOnInboxEditor === true && (
        <SearchKb className={styles.kbSearch} />
      )}
      {showCommentEditor && <Commenting {...editorProps} />}
      {!showCommentEditor && <Replying {...editorProps} />}
    </Fragment>
  )
}

// eslint-disable-next-line react/no-multi-comp
const Footer = ({
  className,
  isReplyFormVisible: replying,
  isAddingNote: commenting,
  ticketId,
  ...rest
}) => {
  return (
    <Switcher
      className={cx(className, { commenting })}
      commenting={commenting}
      replying={replying}
      ticketId={ticketId}
      {...rest}
    />
  )
}

// eslint-disable-next-line react/no-multi-comp
const Styled = styled(Footer)`
  background: #fff;
  margin: 0px 24px 12px;
  flex-grow: 0;
  flex-shrink: 0;
  transition: all 200ms ease-in-out;
  z-index: 200;
  min-height: 201px;

  &.commenting {
    background-color: ${th('colors.note')};
  }
`

// eslint-disable-next-line react/no-multi-comp
class PositioningAndResizeWrapper extends React.PureComponent {
  componentWillUnmount() {
    this.removeObserver()
  }

  setReference = node => {
    if (node) {
      if (this.observer) this.removeObserver()
      this.node = node
      if (!config.isTest) {
        this.observer = new ResizeObserver(this.handleResize)
        this.observer.observe(node)
      }
      this.lastHeight = node.offsetHeight
      this.hasTriggered = false
    }
  }

  removeObserver() {
    this.observer.disconnect()
    this.observer = null
    this.node = null
    this.lastHeight = null
  }

  handleResize = () => {
    const height = this.node.offsetHeight
    if (height !== this.lastHeight || !this.hasTriggered) {
      const diff = height - this.lastHeight
      this.lastHeight = height
      this.hasTriggered = true
      if (this.props.onResize) this.props.onResize(height, diff)
    }
  }

  render() {
    return (
      <div className={styles.positioning} ref={this.setReference}>
        <Styled {...this.props} />
      </div>
    )
  }
}

export default PositioningAndResizeWrapper
